import DateHelper from '@/helpers/date';

const today = DateHelper.getDateToday()
const yesterday = DateHelper.getDateYesterday()
const thisWeek = DateHelper.getStartWeek()
const lastWeek = DateHelper.getStartLastWeek()
const lastWeekEnd = DateHelper.getLastWeekEnd()
const thisMonth = DateHelper.getDateThisMonth()
const lastMonth = DateHelper.getLastMonthStart()
const lastMonthEnd = DateHelper.getLastMonthEnd()
const thisYear = DateHelper.getFirstDayYear()
const lastYear = DateHelper.getFirstDayLastYear()
const lastYearEnd = DateHelper.getLastYearEnd()


export default [
    {
        key: 'today',
        start: today,
        end: today,
        classes: 'btn-white d-block',
        label: 'Today'
    },
    {
        key: 'yesterday',
        start: yesterday,
        end: yesterday,
        classes: 'btn-white d-none d-lg-block d-xl-block',
        label: 'Yesterday'
    },
    {
        key: 'thisWeek',
        start: thisWeek,
        end: today,
        classes: 'btn-white d-none d-lg-block d-xl-block',
        label: 'This week'
    },
    {
        key: 'lastWeek',
        start: lastWeek,
        end: lastWeekEnd,
        classes: 'btn-white d-none d-lg-block d-xl-block',
        label: 'Last week'
    },
    {
        key: 'thisMonth',
        start: thisMonth,
        end: today,
        classes: 'btn-white d-block',
        label: 'This month'
    },
    {
        key: 'lastMonth',
        start: lastMonth,
        end: lastMonthEnd,
        classes: 'btn-white d-block',
        label: 'Last month'
    },
    {
        key: 'thisYear',
        start: thisYear,
        end: today,
        classes: 'btn-white d-none d-lg-block d-xl-block',
        label: 'This year'
    },
    {
        key: 'lastYear',
        start: lastYear,
        end: lastYearEnd,
        classes: 'btn-white d-none d-lg-block d-xl-block',
        label: 'Last year'
    }
]